import React, { memo } from 'react';

import { cn } from '../../lib/styles';

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  titleClassName?: string;
}

const SectionHeaderBase = ({ title, subtitle, className, prefix, suffix, titleClassName }: SectionHeaderProps) => {
  return (
    <div className={cn('flex items-center flex-wrap gap-2 py-3 min-h-14', className)}>
      {prefix}

      <div className="flex min-w-0 flex-col">
        <div
          className={cn(
            'truncate font-body-md font-semibold capitalize text-text-primary dark:text-white',
            titleClassName,
          )}
        >
          {title}
        </div>

        {subtitle ? <div className="truncate font-body-xsm text-text-tertiary">{subtitle}</div> : null}
      </div>

      {suffix ? (
        <>
          <div className="flex-1 ml-2" />

          {suffix}
        </>
      ) : null}
    </div>
  );
};

export const SectionHeader = memo(SectionHeaderBase);
